// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyADgb5ACpYxNyU5LpwYPiy7RvYWFr_hnD8",
    authDomain: "simple-firebase-authenti-ee54c.firebaseapp.com",
    projectId: "simple-firebase-authenti-ee54c",
    storageBucket: "simple-firebase-authenti-ee54c.appspot.com",
    messagingSenderId: "1027893283012",
    appId: "1:1027893283012:web:7411b3975b943b50d26191"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;